import { Button } from "@/components/ui/button";
import { ReactNode } from "react";

interface SCADAActionBarProps {
  onSaveDraft?: () => void;
  onSubmit?: () => void;
  saveDraftLabel?: string;
  submitLabel?: string;
  isOffline?: boolean;
  disabled?: boolean;
  children?: ReactNode;
}

export function SCADAActionBar({
  onSaveDraft,
  onSubmit,
  saveDraftLabel = "Save Draft",
  submitLabel = "Submit",
  isOffline = false,
  disabled = false,
  children,
}: SCADAActionBarProps) {
  const finalSubmitLabel = isOffline ? "Queue Submit" : submitLabel;
  const submitClass = isOffline 
    ? "bg-amber-600 hover:bg-amber-700 text-black font-semibold" 
    : "bg-primary hover:bg-primary/90 text-primary-foreground font-semibold";

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 shadow-lg">
      <div className="container py-3 md:py-4">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 justify-between">
          {/* Left side - custom content */}
          {children && (
            <div className="flex-1">
              {children}
            </div>
          )}
          
          {/* Right side - actions */}
          <div className="flex gap-3">
            {onSaveDraft && (
              <Button
                variant="outline"
                onClick={onSaveDraft}
                disabled={disabled}
                className="flex-1 sm:flex-none min-w-[120px]"
                size="lg"
              >
                {saveDraftLabel}
              </Button>
            )}
            {onSubmit && (
              <Button
                onClick={onSubmit}
                disabled={disabled}
                className={`flex-1 sm:flex-none min-w-[120px] ${submitClass}`}
                size="lg"
              >
                {finalSubmitLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
